var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "swatches-view-wrapper"
  }, [_c('ul', {
    ref: "swatchesViewTabs",
    staticClass: "swatches-view-wrapper-tabs",
    class: {
      'splash-swatches-view-tabs': _vm.isMobile
    }
  }, [_c('li', {
    staticClass: "tab-randomize",
    class: [{
      'hide': !_vm.isRandomizeEnabled || _vm.isApparel
    }, {
      'disabled': _vm.$store.state.utils.isRandomizeApplied
    }]
  }, [_c('button', {
    staticClass: "tab-name tab-randomize__name",
    attrs: {
      "aria-label": _vm.translations.tabRandomize,
      "aria-hidden": !_vm.isRandomizeEnabled || _vm.isApparel,
      "role": "button",
      "id": "randomize"
    },
    on: {
      "click": function click($event) {
        return _vm.onRandomizeClick();
      }
    }
  }, [_vm._m(0), _c('span', {
    staticClass: "tab-randomize__name__value"
  }, [_vm._v(_vm._s(_vm.translations.tabRandomize))]), _c('span', {
    staticClass: "tab-randomize__name__icon icon icon-randomize",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._l(_vm.getTabsSwatches, function (tab) {
    return _c('li', {
      key: tab.name,
      class: ['tab-' + tab.name, {
        active: _vm.active_tab === tab.name
      }, {
        deactivated: _vm.disabledTab(tab) || _vm.rayTracerDisabled
      }, {
        hide: _vm.hideTab(tab)
      }],
      on: {
        "click": function click($event) {
          return _vm.changeTab(tab);
        }
      }
    }, [_c('button', {
      staticClass: "tab-name",
      attrs: {
        "aria-label": _vm.getTabLabel(tab),
        "aria-hidden": _vm.hideTab(tab),
        "role": "button",
        "id": tab.name
      }
    }, [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: tab.name === 'add-your-own',
        expression: "tab.name === 'add-your-own'"
      }]
    }, [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: tab.name === 'add-your-own',
        expression: "tab.name === 'add-your-own'"
      }],
      staticClass: "ugc-upcharge"
    }, [_vm._v(_vm._s(_vm.ugcUpcharge))])]), _c('span', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip",
        value: Object.assign({}, _vm.ugcTooltipData, {
          classes: 'swatches-view-v-popover ugc-tooltip-data'
        }),
        expression: "{ ...ugcTooltipData, classes: 'swatches-view-v-popover ugc-tooltip-data' }"
      }, {
        name: "show",
        rawName: "v-show",
        value: _vm.hasUGCTooltip(tab.name),
        expression: "hasUGCTooltip(tab.name)"
      }],
      staticClass: "ugc-tooltip"
    }, [_vm._v("?")]), _vm._v("\n        " + _vm._s(_vm.getTabLabel(tab)) + "\n        "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: tab.name !== 'add-your-own' && tab.name !== 'image-gallery' && tab.name && tab.name !== 'personalization' && tab.name !== 'yourcolors',
        expression: "tab.name !== 'add-your-own' && tab.name !== 'image-gallery' && tab.name && tab.name !== 'personalization' && tab.name !== 'yourcolors'"
      }],
      staticClass: "configurator-swatch-count"
    }, [_vm._v("(" + _vm._s(!_vm.ugcBlockedTab ? tab.total : 1) + ")")]), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: tab.name === 'add-your-own',
        expression: "tab.name === 'add-your-own'"
      }],
      staticClass: "camera-icon"
    }, [_c('svg', {
      staticStyle: {
        "position": "relative",
        "top": "2px",
        "left": "1px"
      },
      attrs: {
        "width": "16",
        "height": "16",
        "viewBox": "0 0 512 512"
      }
    }, [_c('path', {
      attrs: {
        "d": "M152 304c0 57.438 46.562 104 104 104s104-46.562 104-104-46.562-104-104-104-104 46.562-104 104zM480 128h-112c-8-32-16-64-48-64h-128c-32 0-40 32-48 64h-112c-17.6 0-32 14.4-32 32v288c0 17.6 14.4 32 32 32h448c17.6 0 32-14.4 32-32v-288c0-17.6-14.4-32-32-32zM256 446c-78.425 0-142-63.574-142-142s63.575-142 142-142c78.426 0 142 63.575 142 142s-63.573 142-142 142zM480 224h-64v-32h64v32z"
      }
    })])]), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: tab.name === 'yourcolors',
        expression: "tab.name === 'yourcolors'"
      }],
      staticClass: "color-picker-icon-container"
    }, [_c('span', {
      staticClass: "color-picker-icon"
    })])])]);
  })], 2)]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "tab-randomize__name__dynamic-background"
  }, [_c('div', {
    staticClass: "background-content"
  })]);
}]

export { render, staticRenderFns }